const cancelledTaskIds = new Set();

export function cancelImg2ImgTask(taskId) {
  if (taskId == null || taskId === '') return;
  cancelledTaskIds.add(String(taskId));
}

export function clearImg2ImgTaskCancel(taskId) {
  if (taskId == null || taskId === '') return;
  cancelledTaskIds.delete(String(taskId));
}

export function isImg2ImgTaskCancelled(taskId) {
  if (taskId == null || taskId === '') return false;
  return cancelledTaskIds.has(String(taskId));
}
